<template>
  <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
    <CModal
      :closeOnBackdrop="false"
      :show.sync="modal"
      :no-close-on-backdrop="false"
      :centered="true"
      title=""
      size="lg"
      color="dark"
    >
      <CCard>
        <CCardBody>
          <CAlert
            v-if="alertMsg"
            :color="alertClr"
            closeButton
            fade
          >
            {{ alertMsg }}
          </CAlert>
          <CForm>
            <ValidationProvider
              :rules="`required|max:${constdata.USER_USERID_MAX_LEN}`"
              v-slot="{ errors }"
              name="ユーザーID"
            >
              <CInput
                label="ユーザーID *"
                v-model="inputItems.user_id"
                readonly
                horizontal
                @change="applyChanges"
              />
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              :rules="`required|max:${constdata.USER_LASTNAME_MAX_LEN}`"
              v-slot="{ errors }"
              name="姓"
            >
              <CInput label="姓 *" v-model="inputItems.lastname" horizontal @change="applyChanges"/>
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              :rules="`required|max:${constdata.USER_LASTNAME_KANA_MAX_LEN}`"
              v-slot="{ errors }"
              name="セイ"
            >
              <CInput
                label="セイ *"
                v-model="inputItems.lastname_kana"
                horizontal
                @change="applyChanges"
              />
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              :rules="`required|max:${constdata.USER_FIRSTNAME_MAX_LEN}`"
              v-slot="{ errors }"
              name="名"
            >
              <CInput label="名 *" v-model="inputItems.firstname" horizontal @change="applyChanges"/>
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              :rules="`required|max:${constdata.USER_FIRSTNAME_KANA_MAX_LEN}`"
              v-slot="{ errors }"
              name="メイ"
            >
              <CInput
                label="メイ *"
                v-model="inputItems.firstname_kana"
                horizontal
                @change="applyChanges"
              />
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              :rules="`required|email|max:${constdata.USER_EMAIL_MAX_LEN}`"
              v-slot="{ errors }"
              name="メールアドレス"
            >
              <CInput
                label="メールアドレス *"
                v-model="inputItems.email"
                horizontal
                @change="applyChanges"
              />
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              :rules="`max:${constdata.USER_NATIONALITY_MAX_LEN}`"
              v-slot="{ errors }"
              name="国籍"
            >
              <CInput
                label="国籍"
                v-model="inputItems.nationality"
                horizontal
                @change="applyChanges"
              />
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <CInput
              label="生年月日"
              type="date"
              min="1970-01-01"
              max="2070-12-31"
              v-model="inputItems.birthday"
              horizontal
              @change="applyChanges"
            />
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="性別"
            >
              <CSelect
                label="性別 *"
                horizontal
                :value.sync="inputItems.gender_id"
                :options="genders"
                placeholder="選択してください"
                @change="applyChanges"
              />
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              :rules="`max:${constdata.USER_NEAREST_MAX_LEN}`"
              v-slot="{ errors }"
              name="最寄り駅"
            >
              <CInput
                label="最寄り駅"
                v-model="inputItems.nearest_station"
                horizontal
                @change="applyChanges"
              />
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="最終学歴"
            >
              <CSelect
                label="最終学歴 *"
                horizontal
                :value.sync="inputItems.latest_academic_id"
                :options="educations"
                placeholder="選択してください"
                @change="applyChanges"
              />
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              :rules="`between:${constdata.USER_GRADUATE_YEAR_MIN_VAL},${constdata.USER_GRADUATE_YEAR_MAX_VAL}`"
              v-slot="{ errors }"
              name="卒業年度"
            >
              <CInput
                label="卒業年度"
                v-model.number="inputItems.graduate_year"
                type="number"
                horizontal
                @change="applyChanges"
              />
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              :rules="`required|between:${constdata.USER_YEARS_EXPERIENCE_MIN_VAL},${constdata.USER_YEARS_EXPERIENCE_MAX_VAL}`"
              v-slot="{ errors }"
              name="IT業界経験年数"
            >
              <CInput
                label="入社前業界経験年数 *"
                v-model.number="inputItems.years_experience"
                type="number"
                horizontal
                @change="applyChanges"
              />
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="就業状態"
            >
              <CSelect
                label="就業状態 *"
                horizontal
                :value.sync="inputItems.employment_status"
                :options="employments"
                placeholder="選択してください"
                @change="changeEmployStat()"
              />
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              name="入社年月日"
              vid="joining_date"
              rules=""
            >
              <CInput
                label="入社年月日"
                type="date"
                min="1970-01-01"
                max="2070-12-31"
                v-model="inputItems.joining_date"
                horizontal
                @change="applyChanges"
              />
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              v-slot="{ errors }"
              name="退職日"
              :rules="{ required: needRetirementDate, period: `joining_date` }"
            >
              <CInput
                label="退職日"
                type="date"
                min="1970-01-01"
                max="2070-12-31"
                v-model="inputItems.retirement_date"
                horizontal
                :lazy="true"
                @update:value="updateRetireDate($event)"
                @change="applyChanges"
              />
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="役職"
            >
              <!-- 役職(v-select) -->
              <div class="form-group form-row">
                <label class="col-form-label col-sm-3">役職 *</label>
                <div class="col-sm-9">
                  <v-select
                    label="position_name"
                    placeholder="選択してください"                    
                    v-model="inputItems.position_id"
                    :options="positions"
                    :reduce="(v) => v.position_id"
                    @input="applyChanges"
                  >
                    <template #no-options> 選択肢が見つかりません。 </template>
                  </v-select>
                </div>
              </div>
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="所属組織"
            >
              <!-- 所属組織(v-select) -->
              <div class="form-group form-row">
                <label class="col-form-label col-sm-3">所属組織 *</label>
                <div class="col-sm-9">
                  <v-select
                    label="organization_name"
                    placeholder="選択してください"             
                    v-model="inputItems.organization_id"
                    :options="organizations"
                    :reduce="(v) => v.organization_id"
                    @input="applyChanges"
                  >
                    <template #no-options> 選択肢が見つかりません。 </template>
                  </v-select>
                </div>
              </div>
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="契約形態"
            >
              <CSelect
                label="契約形態 *"
                horizontal
                :value.sync="inputItems.working_status"
                :options="contracts"
                placeholder="選択してください"
                @change="applyChanges"
              />
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              rules="required"
              v-slot="{ errors }"
              name="閲覧権限"
            >
              <!-- 閲覧権限(v-select) -->
              <div class="form-group form-row">
                <label class="col-form-label col-sm-3">閲覧権限 *</label>
                <div class="col-sm-9">
                  <v-select
                    label="authority_name"
                    placeholder="選択してください"
                    v-model="inputItems.authority_id"
                    :options="authorities"
                    :reduce="(v) => v.authority_id"
                    @input="applyChanges"
                  >
                    <template #no-options> 選択肢が見つかりません。 </template>
                  </v-select>
                </div>
              </div>
              <div class="validation-error">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
          </CForm>
        </CCardBody>
      </CCard>
      <template #header>
        <h6 class="modal-title" ref="modal-title">ユーザーマスタ更新</h6>
        <CButtonClose @click="closeModal" class="text-white" />
      </template>
      <template #footer>
        <CButton
          @click="alertValidation(handleSubmit(update))"
          color="success"
          v-if="hasMasterEditAuthorityProp"
          >更新</CButton
        >
      </template>
    </CModal>
  </ValidationObserver>
</template>

<script>
//TODO 定数定義のコンポーネント群は共通に移す
import contracts from "../../../../definition/working-status.json";
import educations from "../../../../definition/latest-academic.json";
import employments from "../../../../definition/employment-status.json";
import genders from "../../../../definition/gender.json";
import constdata from "../../../../definition/const/const_user.js";
import constMsg from "../../../../definition/const/const_message.js";

export default {
  name: "UserEditModal",
  data() {
    return {
      contracts: contracts,
      educations: educations,
      employments: employments,
      genders: genders,
      constdata: constdata,
      positions: [],
      organizations: [],
      authorities: [],
      modal: false,
      updateFlag: false,
      alertMsg: "",
      alertClr: "",
      needRetirementDate: false,
    };
  },
  watch: {
    visible: {
      handler: function () {
        this.modal = this.visible;
        // 更新モーダル画面表示ON時処理
        if (this.visible) {
          // 退職状態の制御処理
          this.togggleRetirementValidate();
        }
      },
    },
  },
  computed: {
    inputItems() {
      return { ...this.data };
    },
  },
  props: {
    visible: {
      type: Boolean, // Boolean型に限定
      required: true, // 必須項目
    },
    data: {
      type: Object,
    },
    hasMasterEditAuthorityProp: {
      type: Boolean,
    },
  },
  async mounted() {
    // 初期データ取得
    await this.fetchData();
  },
  methods: {
    // 退職状態の制御関数
    togggleRetirementValidate() {
      this.needRetirementDate = false;
      let selectedVal = this.inputItems.employment_status;
      if (selectedVal === constdata.RETIREMENT_CODE) {
        // 「退職済・契約解除」が選択された場合、退職日項目の必須属性をTrueにする。
        this.needRetirementDate = true;
      } else {
        // 「退職済・契約解除」以外が選択された場合、退職日を初期化する。
        this.inputItems.retirement_date = null;
      }
    },
    // 「就業状態」変更時イベント関数
    changeEmployStat() {
      this.applyChanges();
      // 退職状態の制御処理
      this.togggleRetirementValidate();
    },
    // 「退職日」変更時イベント関数
    updateRetireDate(inputVal) {
      // 退職日に値が入力された場合
      if (inputVal !== null) {
        // 就業状態を「退職済・契約解除」にする。
        this.inputItems.employment_status = constdata.RETIREMENT_CODE;
        // 退職日項目の必須属性をTrueにする。
        this.needRetirementDate = true;
      }
    },
    applyChanges(){
      this.updateFlag = true;
    },
    closeModal() {
      // バリデーションエラーのメッセージを非表示
      this.alertMsg = "";
      // 画面クローズ
      if(this.updateFlag == true){
      var result = confirm('内容が変更されています。ウインドウを閉じますか？');
      if(result === false) {
        return;
      }
      }
      this.updateFlag = false;
      this.modal = false;
      this.$emit("close");
    },
    alertValidation() {
      // バリデーションエラーがあればエラーメッセージを表示
      this.$refs.observer.validate().then((success) => {
        if (!success) {
          // モーダルを閉じずにバリデーションエラーメッセージを表示
          this.alertClr = "danger";
          this.alertMsg =
            "入力内容に不備があります。詳細は各項目を確認してください。";
          // モーダルトップへスクロール
          this.$refs["modal-title"].scrollIntoView({
            behavior: "smooth",
            block: "end",
          });
        }
      });
    },
    async update() {
      var id = this.inputItems.user_id;
      // ログインユーザーIDをパラメーターに含める
      this.inputItems.login_user_id = this.$store.state.loginUser.user_id;
      // 更新処理
      const ret = await this.updateUser(id, this.inputItems);
      // バリデーションエラーのメッセージを非表示
      this.alertMsg = "";
      // 画面クローズ
      this.modal = false;
      this.$emit("close", ret);
    },
    async updateUser(id, param) {
      let ret = {};
      await this.$axios
        .put("/api/v1/users/" + id, param)
        .then((res) => {
          ret.alertClr = "success";
          ret.alertMsg = constMsg.I0003_JP;
        })
        .catch((e) => {
          ret.alertClr = "danger";
          ret.alertMsg = e.response.data.message;
        });
      return ret;
    },
    async fetchData() {
      // 役職リストデータセット
      this.positions = await this.getPositionList();
      // 所属組織リストデータセット
      this.organizations = await this.getOrganizationList();
      // 閲覧権限リストデータセット
      this.authorities = await this.getAuthorityList();
    },
    async getPositionList() {
      let ret = null;
      await this.$axios
        .get("/api/v1/positions")
        .then((res) => {
          ret = res.data.positions;
        })
        .catch((e) => {
          console.error(e.response.data.message);
        });
      return ret;
    },
    async getOrganizationList() {
      let ret = null;
      await this.$axios
        .get("/api/v1/organizations")
        .then((res) => {
          ret = res.data.organizations;
        })
        .catch((e) => {
          console.error(e.response.data.message);
        });
      return ret;
    },
    async getAuthorityList() {
      let ret = null;
      await this.$axios
        .get("/api/v1/authorities")
        .then((res) => {
          ret = res.data.authorities;
        })
        .catch((e) => {
          console.error(e.response.data.message);
        });
      return ret;
    },
  },
};
</script>